import { render, staticRenderFns } from "./select-custom.vue?vue&type=template&id=01623ca3&"
import script from "./select-custom.vue?vue&type=script&lang=js&"
export * from "./select-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/select-custom/select-custom.vue
// module id = 275
// module chunks = 0